import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["for"]
const _hoisted_2 = ["id", "placeholder", "value"]
const _hoisted_3 = { disabled: "" }
const _hoisted_4 = ["value"]

import { computed } from 'vue';
  
  // Props
  
export default /*#__PURE__*/_defineComponent({
  __name: 'SelectField',
  props: {
    label: null,
    id: null,
    placeholder: null,
    modelValue: null,
    param: null,
    selectClasses: null,
    options: null,
    className: null
  },
  setup(__props: any) {

const {
    label,
    id,
    placeholder = 'Select an option',
    modelValue,
    selectClasses: customSelectClasses, // Custom select classes prop
    options,
    param,
    className
  } = __props as {
    label: string;
    id: string;
    placeholder?: string;
    modelValue: any;
    param: string;
    selectClasses?: string; // Custom select classes prop
    options: Array<{ id: any; text: string }>;
    className: string;
  };

   
  
  // Default select classes
  const defaultSelectClasses = computed(() => {
    const classes = [
      'bg-gray-50',
      'border',
      'border-gray-300',
      'text-gray-900',
      'text-sm',
      'rounded-lg',
      'focus:ring-blue-500',
      'focus:border-blue-500',
      'block',
      'w-full',
      'p-2.5',
      'dark:bg-gray-700',
      'dark:border-gray-600',
      'dark:placeholder-gray-400',
      'dark:text-white',
      'dark:focus:ring-blue-500',
      'dark:focus:border-blue-500',
    ];
  
    return classes.join(' ');
  });
  
return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["text-left", __props.className])
  }, [
    _createElementVNode("label", {
      for: __props.id,
      class: "text-left block mb-2 text-sm font-medium text-gray-900 dark:text-white"
    }, _toDisplayString(__props.label), 9, _hoisted_1),
    _createElementVNode("select", {
      id: __props.id,
      class: _normalizeClass([_unref(defaultSelectClasses), _ctx.customSelectClasses]),
      placeholder: __props.placeholder,
      value: __props.modelValue,
      onInput: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:modelValue', $event?.target?.value)))
    }, [
      _createElementVNode("option", _hoisted_3, _toDisplayString(__props.placeholder), 1),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.options, (option) => {
        return (_openBlock(), _createElementBlock("option", {
          value: option.id
        }, _toDisplayString(option[__props.param]), 9, _hoisted_4))
      }), 256))
    ], 42, _hoisted_2)
  ], 2))
}
}

})